import React from 'react'
import { withRouter } from 'react-router-dom'
import 'primeicons/primeicons.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primereact/resources/primereact.css'
import 'primeflex/primeflex.css'
import './DropdownDemo.css'

import { api, request } from '../../util/handlerRequestUtil'

import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import BtnImportationStatusRenderer from './BtnImportationStatusRenderer'
import { Modal } from 'antd'
import CreateDataLoads from './CreateDataLoad'
import { getMessage } from '../../util/IntlMessages'
import moment from 'moment'

class ListDataLoads extends React.Component {
  constructor(props) {
    super(props)
    this.gridApi = {}
    this.state = {
      showModalCreate: false,
      showModalStatus: false,
      tiposDado: [],
      selectedTipo: null,
      idTipo: null,
      columnDefs: [
        { headerName: 'Arquivo', field: 'nomeArquivo', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Tipo de importação', field: 'tipoCarga', width: 30, filter: 'agTextColumnFilter' },
        {
          headerName: 'Data',
          field: 'dataCarga',
          width: 15,
          filter: 'agDateColumnFilter',
          cellRenderer: (params) => {
            return moment(String(params.value).slice(0, 10)).format('DD/MM/YYYY')
          },
          filterParams: {
            comparator: (filter, value) => {
              const momentFilter = moment(filter.slice(0, 10)).format('YYYY/MM/DD')
              const momentValue = moment(value.slice(0, 10)).format('YYYY/MM/DD')

              if (momentFilter > momentValue) {
                return -1
              } else if (momentValue > momentFilter) {
                return 1
              }
              return 0
            }
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 10,
          filter: 'agTextColumnFilter',
          cellRenderer: ({ data }) => <BtnImportationStatusRenderer carga={data} />,
          colId: 'params'
        }
      ],
      context: { componentParent: this },
      defaultColDef: {
        sortable: true,
        resizable: true,
        minWidth: 1,
        width: 100,
        enableRowGroup: false,
        enablePivot: false,
        enableValue: true,
        floatingFilter: true
      },
      // sideBar: {
      //   toolPanels: ['columns']
      // },
      // rowGroupPanelShow: 'always',
      // pivotPanelShow: 'always',
      rowData: null
    }
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  componentDidMount() {
    this.fetchDataTypes()
  }

  showModal = () => {
    this.setState({ showModalCreate: true })
  }

  hideModal = () => {
    this.setState({ showModalCreate: false })
    window.location.reload()
  }

  onTipoChange = (e) => {
    this.setState({
      selectedTipo: e.value,
      idTipo: e.value.code
    })
  }

  async listDataLoad(params) {
    return await request(api.getDataLoad(params))
  }

  async fetchDataTypes() {
    const items = await request(api.getDataTypes())
    const typesById = {}
    const formattedItems = items.map((item) => {
      typesById[item.id] = item
      return { code: item.id, name: item.descricao }
    })
    this.setState({
      tiposDado: formattedItems
    })
  }

  async salvarArquivo(file, idtipocarga) {
    await request(api.saveDataLoadFile(file, idtipocarga))
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    params.api.sizeColumnsToFit()

    this.listDataLoad().then((data) => params.api.setRowData(data))
  }

  renderHeader() {
    const leftContents = (
      <React.Fragment>
        <h2>
          <b>Últimas Importações</b>
        </h2>
      </React.Fragment>
    )

    const rightContents = (
      <React.Fragment>
        <div style={{ display: 'flex', marginRight: 8 }}>
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              style={{ width: '100%' }}
              value={this.state.value3}
              onChange={(e) => this.gridApi.setQuickFilter(e.target.value)}
              placeholder="Pesquisar"
            />
          </IconField>
        </div>
        <Button icon="pi pi-file-excel" className="p-button-success mr-2" onClick={() => this.onBtnExport()} />

        <Dropdown
          value={this.state.selectedTipo}
          options={this.state.tiposDado}
          onChange={this.onTipoChange}
          optionLabel="name"
          placeholder="Selecione o tipo de importação"
          style={{ marginLeft: 10, width: 300, height: 45, marginRight: 10 }}
          required
        />

        <Button
          style={{
            marginLeft: '10px'
          }}
          icon="pi pi-plus"
          disabled={this.state.selectedTipo === null}
          onClick={this.showModal}
        />
        <Modal
          title={getMessage('newImport')}
          footer={null}
          onCancel={() => {
            this.hideModal()
          }}
          width="70%"
          visible={this.state.showModalCreate}
          onClose={() => {
            this.hideModal()
          }}
        >
          <CreateDataLoads
            currentStep={0}
            idTipoCarga={this.state.idTipo}
            salvarArquivo={this.salvarArquivo}
            setIsModalLocationVisible={this.hideModal}
          />
        </Modal>
      </React.Fragment>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        <div style={{ width: '100%', height: '70vh' }}>
          <div
            style={{
              height: '100%',
              width: '100%'
            }}
            className="ag-theme-alpine"
          >
            <AgGridReact
              columnDefs={this.state.columnDefs}
              defaultColDef={this.state.defaultColDef}
              onGridReady={this.onGridReady}
              rowData={this.state.rowData}
              context={this.state.context}
              rowSelection={'single'}
            />
          </div>
        </div>
      </>
    )
  }

  onBtnExport = () => {
    this.gridApi.exportDataAsCsv()
  }
}

export default withRouter(ListDataLoads)
